import { Card, Group, Stack, Text, useMantineColorScheme } from '@mantine/core'

interface Props {
  children?: React.ReactNode
  title?: React.ReactNode
  description?: string
  icon?: React.ReactNode
  extraHeader?: React.ReactNode
  className?: string
}

export const TowerCard: React.FC<Props> = ({
  children,
  title,
  description,
  icon,
  extraHeader,
  className,
}) => {
  const colorScheme = useMantineColorScheme()
  const isDark = colorScheme.colorScheme === 'dark'

  return (
    <Card radius="md" withBorder shadow="sm" className={className}>
      {(title || description) && (
        <Card.Section
          p="md"
          style={{
            background: isDark
              ? `linear-gradient(to right, var(--mantine-color-dark-7), var(--mantine-color-dark-5))`
              : `linear-gradient(to right, var(--mantine-color-gray-0), var(--mantine-color-gray-1))`,
            borderBottom: `1px solid ${isDark ? 'var(--mantine-color-dark-4)' : 'var(--mantine-color-gray-3)'}`,
          }}
        >
          <Group justify="space-between" wrap="nowrap">
            <Stack gap={0}>
              <Group gap="xs">
                {icon}
                <Text fw={700} size="lg">
                  {title}
                </Text>
              </Group>
              {description && (
                <Text size="sm" c="dimmed">
                  {description}
                </Text>
              )}
            </Stack>
            {extraHeader}
          </Group>
        </Card.Section>
      )}
      <Card.Section p="md">{children}</Card.Section>
    </Card>
  )
}
